module.exports = __webpack_public_path__ + "img/ec10d3599a082bfdd54b5226a414279b.svg";